import React, { useState } from 'react';
import { Button, Upload as UploadAntd, message } from 'antd';
import { api } from 'react-structure-admin';
import { LoadingOutlined, PaperClipOutlined } from '@ant-design/icons';
import join from 'util/functions/join';
import ShowFilesModal from './ShowFilesModal';

const Upload = ({
  value,
  onChange,
  disabled,
  buttonName = 'Anexar',
  params,
  extensions = []
}) => {
  const [loading, setLoading] = useState(false);
  const [openShowFile, setOpenShowFile] = useState(null);
  const { name } = value ?? {};

  const handleOnRemove = () => {
    onChange(null);
  };

  const extractingExtension = (fileName) => {
    const text = fileName.match(/\.[0-9a-z]+$/i)[0];
    return text != null ? text : '';
  };

  const handlePreview = () => {
    setOpenShowFile(value);
  };

  const handleClosePreview = () => {
    setOpenShowFile(null);
  };

  const handleBeforeUpload = (file) => {
    let isCorrectFormat = false;

    if (extensions.includes(file.type.replace('image/', '').toLowerCase())) {
      isCorrectFormat = true;
    } else if (
      extensions.includes(extractingExtension(file.name).replace('.', ''))
    ) {
      isCorrectFormat = true;
    }

    if (!isCorrectFormat) {
      message.error(
        `É permitido somente arquivos com a extensão ${join(
          extensions.map((c) => c.toUpperCase()),
          ', ',
          ' e '
        )}.`
      );
    }

    const isLt3M = file.size / 1024 / 1024 < 3;

    if (!isLt3M) {
      message.error('O tamanho do arquivo não pode ser superior a 3MB');
    }

    return isCorrectFormat && isLt3M;
  };

  const handleDownload = (file) => {
    const link = document.createElement('a');
    link.href = file.url;
    link.download = file.name;
    link.click();
  };

  const handlerUploadError = () => {
    message.error('Ocorreu um erro inesperado ao processar sua solicitação.');
  };

  const customRequest = (options) => {
    const data = new FormData();

    data.append('file', options.file);

    if (params) {
      Object.keys(params).forEach((key) => {
        data.set(key, params[key]);
      });
    }

    setLoading(true);

    api.post('archives', data).then((response) => {
      if (!(response && response.errors)) {
        if (!Array.isArray(value)) {
          value = [];
        }

        onChange(response.data.result);
        options.onSuccess(options.file, options.data);
        setLoading(false);
        return;
      }

      options.onError();
      handlerUploadError();
      setLoading(false);
    });
  };

  const truncateFilename = (filename) => {
    const dotIndex = filename.lastIndexOf('.');
    if (dotIndex === -1) {
      return filename.length <= 12 ? filename : filename.slice(0, 12);
    }

    const name = filename.slice(0, dotIndex);
    const extension = filename.slice(dotIndex);

    const truncatedName = name.length <= 12 ? name : name.slice(0, 12);

    return `${truncatedName}...${extension}`;
  };

  return (
    <>
      {openShowFile && (
        <ShowFilesModal
          files={value}
          initialValue={openShowFile}
          onClose={handleClosePreview}
        />
      )}
      <UploadAntd
        className="gx-upload-archive"
        listType="picture-card"
        onRemove={handleOnRemove}
        onDownload={handleDownload}
        onPreview={handlePreview}
        beforeUpload={handleBeforeUpload}
        customRequest={customRequest}
        showUploadList={false}
      >
        <Button
          className="gx-w-100"
          type="ghost"
          disabled={loading || disabled}
          icon={loading ? <LoadingOutlined /> : <PaperClipOutlined />}
        >
          {loading ? 'Carregando...' : null}
          {!loading && !value ? buttonName : null}
          {!loading && value ? truncateFilename(name) : null}
        </Button>
      </UploadAntd>
    </>
  );
};

export default Upload;
